import { render, staticRenderFns } from "./uploadList.vue?vue&type=template&id=656b1675&scoped=true"
import script from "./uploadList.vue?vue&type=script&lang=js"
export * from "./uploadList.vue?vue&type=script&lang=js"
import style0 from "./uploadList.vue?vue&type=style&index=0&id=656b1675&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b1675",
  null
  
)

export default component.exports